import { useCallback, useEffect, useState } from "react";
import { ItemCategoryModel } from "../models/ItemCategoryModel";

export function useCategorySelector(
    categories: ItemCategoryModel[]
) {

    const [subCategories, setSubCategories] = useState<ItemCategoryModel[]>([]);
    const [selectedRootCategory, setSelectedRootCategory] = useState<number | null>(null);
    const [selectedSubCategory, setSelectedSubCategory] = useState<number | null>(null);
    const findCategoryParentChildById = (categories: ItemCategoryModel[], categoryId: number) => {
        for (const parent of categories) {

            if(parent.id === categoryId)
                return {parent:parent, child:null};
            // Check if it has children
            if (parent.children && parent.children.length > 0) {
                for (const child of parent.children) {
                    if (child.id === categoryId) {
                        return { parent: parent, child: child };
                    }
                }
            }
        }

        // If nothing found
        return null;
    };
    const getSubCategories = useCallback((parentId: number) => {
        const subCategories = categories.find((cat: ItemCategoryModel) => cat.id === parentId)?.children || [];
        return subCategories;
    }, [categories]);

    const initCategoryDropdown = useCallback((categoryId: number) => {
        const categoryPair = findCategoryParentChildById(categories, categoryId);
        if (categoryPair) {
            setSelectedRootCategory(categoryPair.parent.id);
            setSubCategories(categoryPair.parent.children);
            setSelectedSubCategory(categoryPair.child ? categoryPair.child.id : null);
        }
        else {
            setSelectedRootCategory(null);
            setSubCategories([]);
            setSelectedSubCategory(null);
        }
    },[categories]);

    const getCategoryNameById = useCallback((categoryId: number): string | null => {
        const category = categories.find(cat => cat.id === categoryId);
        if(category){
            return category.name;
        }
        else {
            for (const parent of categories) {
                const child = parent.children?.find(c => c.id === categoryId);
                if (child) {
                    return child.name;
                }
            }
        }
        return "-";
    }, [categories]);

    const getParentCategoryNameById = useCallback((categoryId: number): string | null => {
        
        const categoryPair = findCategoryParentChildById(categories, categoryId);
        if(categoryPair){
            const parentId = categoryPair?.parent.id;
            const category = categories.find(cat => cat.id === parentId);
            if (category) {
                return category.name;
            }
        }
        return null;
    }, [categories, findCategoryParentChildById]);

      const getSubCategoryNameById = useCallback((subCategoryId: number): string | null => {
        for (const parent of categories) {
            const child = parent.children?.find(c => c.id === subCategoryId);
            if (child) {
                return child.name;
            }
        }
        return null;
    }, [categories]);

    useEffect(() => {
        if (selectedRootCategory !== null) {
            setSubCategories(getSubCategories(selectedRootCategory));

        } else {
            setSubCategories([]);
            setSelectedSubCategory(null);
        }
    }, [selectedRootCategory, getSubCategories]);

    return {
        selectedRootCategory,
        setSelectedRootCategory,
        selectedSubCategory,
        setSelectedSubCategory,
        subCategories,
        getSubCategories,
        getSubCategoryNameById,
        getParentCategoryNameById,
        getCategoryNameById,
        initCategoryDropdown
    };
}